<template>
    <button class="loader-btn btn" :class="rootClasses">
        <dot-loader class="loader-btn--loader" :is-active="isLoading"/>
        <span class="loader-btn--content">
            <slot/>
        </span>
    </button>
</template>

<script>
    import bemMixin from 'framework/mixins/bem';
    import DotLoader from 'framework/components/loaders/dot-loader/dot-loader';

    export default {
        components: {
            DotLoader,
        },
        mixins: [
            bemMixin('loader-btn'),
        ],
        inheritAttrs: false,
        props: {
            /** @type {string[]} */
            btnFacets: {
                type: Array,
                required: true,
            },
            isLoading: {
                type: Boolean,
                required: true,
            },
        },
        computed: {
            /** @type {string[]} */
            rootClasses: {
                get() {
                    return [
                        this.bemAdd(this.isLoading ? 'is-disabled' : ''),
                        this.bemAdd(this.isLoading ? 'is-loading' : ''),
                        ...this.btnFacets.map(facet => this.bemAdd(facet, null, 'btn')),
                    ];
                },
            },
        },
    };
</script>
